// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2-AZw","colCheckbox":"styles_colCheckbox__tCJvY"};